<template>
  <div id="page-shops-list">
    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="6">
        <h2 class="breadcrumb">Ομάδες</h2>
      </vs-col>
      <vs-col vs-w="6">
        <vs-button @click="openPopUp" color="primary" type="filled" icon="add" class="ml-auto mb-2">
          Προσθήκη
        </vs-button>
      </vs-col>
    </vs-row>

    <!-- START: ADD NEW POPUP -->
    <div>
      <validation-observer v-slot="{invalid}">
        <form>
          <vs-popup class="holamundo" :title="displayPopUpTitle" :active="displayPopUp" @close="closePopUp">

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Όνομα</span><span>*</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="name"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>e-mail</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="email"/>
                </div>
              </div>
            <!-- start::sendMassiveEmail -->
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Αποστολή συγκεντρωτικού email</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <input type="checkbox" v-model="sendMassiveEmail" />
              </div>
            </div>
            <!-- end::sendMassiveEmail -->

            <!-- start::sendOnlyChanges -->
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Αποστολή email μόνο αλλαγών</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <input type="checkbox" v-model="sendOnlyChanges" />
              </div>
            </div>
            <!-- end::sendOnlyChanges -->



            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button :disabled="invalid" class="mb-2 text-right" @click.prevent="addRecord">
                  Αποθήκευση
                </vs-button>
              </div>
            </div>
          </vs-popup>
        </form>
      </validation-observer>
    </div>
    <!-- END: ADD NEW POPUP -->

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">
                {{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
                -
                {{ groups.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : groups.length }}
                of
                {{ groups.length }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" placeholder="Αναζήτηση..."/>
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="groups" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
                   :floatingFilter="true"
                   :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true"
                   :enableRtl="$vs.rtl"
                   :paginationAutoPageSize="true" :filter="true" :resizable="true"
                   @rowDoubleClicked="editItem">
      </ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage"/>
    </div>
  </div>
</template>
<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './cell-renderer-groups/CellRendererActions.vue'

// Validation
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Πεδίο υποχρεωτικό',
})

export default {
  components: {
    AgGridVue,
    CellRendererActions,

    // Validation
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      initiated: false,
      switch1: true,
      searchQuery: '',
      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: 'always',
        colResizeDefault: 'shift',
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Όνομα',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 2,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: '',
          field: 'id',
          width: 90,
          filter: false,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          suppressNavigable: true,
          cellClass: 'no-border',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions,
      },
    }
  },
  computed: {
    // Name getter and setter
    name: {
      get() {
        if (this.$store.getters.getGroup) {
          return this.$store.getters.getGroup.name
        }
      },
      set(value) {
        this.$store.dispatch('groupNameSetter', value)
      },
    },
    email: {
      get() {
        if (this.$store.getters.getGroup) {
          return this.$store.getters.getGroup.email
        }
      },
      set(value) {
        this.$store.dispatch('groupEmailSetter', value)
      },
    },
    sendOnlyChanges: {
      get() {
        if (this.$store.getters.getGroup) {
          return this.$store.getters.getGroup.sendOnlyChanges
        }
      },
      set(value) {
        this.$store.dispatch('groupSendOnlyChangesSetter', value)
      },
    },
    sendMassiveEmail: {
      get() {
        if (this.$store.getters.getGroup) {
          return this.$store.getters.getGroup.sendMassiveEmail
        }
      },
      set(value) {
        this.$store.dispatch('groupSendMassiveEmailSetter', value)
      },
    },
    // The Groups
    groups() {
      return this.$store.getters.getGroups
    },
    // Group
    item() {
      return this.$store.getters.getGroup
    },
    // Display pop up
    displayPopUp() {
      return this.$store.getters.getDisplayGroupPopUp
    },
    // Display pop up title
    displayPopUpTitle() {
      return this.$store.getters.getDisplayGroupPopUpTitle
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      },
    },
  },
  methods: {
    editItem(value) {
      this.$store.dispatch('setGroup', value.data)
      this.$store.dispatch(
          'setGroupPopUpTitle',
          `Επεξεργασία όμαδας (${value.data.name})`
      )
      this.$store.dispatch('toggleGroupPopUp', true)
    },
    // Open pop up
    openPopUp() {
      // 1. Open pop up
      this.$store.dispatch('toggleGroupPopUp', true)
      // 2. Set pop up title
      this.$store.dispatch('setGroupPopUpTitle', 'Νέα εγγραφή ομάδας')
      // 3. Set new group to an empty object
      this.$store.dispatch('setGroup', {name: ''})
    },
    // Close pop up
    closePopUp() {
      // 1. Close pop up
      this.$store.dispatch('toggleGroupPopUp', false)
      // 2. Set pop up title
      this.$store.dispatch('setGroupPopUpTitle', '')
      // 3. Set new group to an empty object
      this.$store.dispatch('setGroup', {name: ''})
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addRecord() {
      // Update group if item.id exists
      if (this.item.id) {
        this.$store
            .dispatch('updateGroup', this.item)
            .then(() => {
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })
              this.closePopUp()
            })
            .catch((err) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
              console.error(err)
            })
      } else {
        this.$store
            .dispatch('addNewGroup', this.item)
            .then(() => {
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })
              this.closePopUp()
            })
            .catch((err) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
              console.error(err)
            })
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
          '.ag-header-container'
      )
      header.style.left = `-${String(
          Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created() {
    this.$store.dispatch('fetchGroups')
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
